import { PAGES } from 'consts/pages';
import type { Page } from 'consts/pages';
import type { Milliseconds } from 'types/time';

export const TIME_IN_DAY_FORMAT_WITHOUT_SECONDS = 'HH:mm';
export const PQL_TIME_IN_DAY_FORMAT_WITHOUT_SECONDS = 'hh:mmaa';
export const US_FULL_DATE = 'MM/dd/yyyy hh:mm aa';
export const US_TIME_IN_DAY = 'hh:mm aa';
export const TIME_IN_DAY_FORMAT = 'HH:mm:ss';
export const DAY_IN_WEEK_SHORT_FORMAT = 'dd';
export const DAY_IN_YEAR_FORMAT = 'MM/dd/yyyy';
export const DAY_IN_YEAR_PQL_FORMAT = 'M/d/yyyy';
export const DAY_IN_YEAR_SHORT_FORMAT = 'MM/dd/yy';
export const DAY_MONTH_ABBR_FORMAT = 'MMM do';
export const DAY_MONTH_FORMAT = 'MMMM do';
export const DAY_MONTH_YEAR_ABBR_FORMAT = `${DAY_MONTH_ABBR_FORMAT}, yyyy`;
export const MONTH_YEAR_FULL_FORMAT = 'MMMM yyyy';
export const MONTH_YEAR_SHORT_FORMAT = 'MM/dd';
export const FULL_DATE_FORMAT = `${DAY_IN_YEAR_FORMAT} ${TIME_IN_DAY_FORMAT_WITHOUT_SECONDS}`;
export const PQL_FULL_DATE_FORMAT = `${DAY_IN_YEAR_FORMAT} ${PQL_TIME_IN_DAY_FORMAT_WITHOUT_SECONDS}`;
export const RECORD_HEADER_FORMAT = `MMMM dd, yyyy, EEEE, ${TIME_IN_DAY_FORMAT}`;
export const SHORT_DAY_NAME_FORMAT = 'EEEEEE';

export const MIN_INTERVAL: { [key in Page]?: Milliseconds } & { default: Milliseconds } = {
  [PAGES.events]: (60 * 60 * 1000) as Milliseconds, // 1 hour in ms
  default: (60 * 1000) as Milliseconds,
};

export const MONTHS: string[] = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const DAYS_IN_WEEK: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
